import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "zoom" }
const _hoisted_5 = { class: "actions" }

import { ref, watch } from "vue";
import { svgIcon } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'header',
  props: {
    zoom: {}
  },
  emits: ["update:zoom", "close", "download"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const zoomInputValue = ref((props.zoom * 100).toFixed(0));
let intervalId: number | null = null;

// Sincronizar input com prop zoom
watch(
  () => props.zoom,
  (newZoom) => {
    zoomInputValue.value = (newZoom * 100).toFixed(0);
  },
);

const handleZoomDecrease = () => {
  const newZoom = Math.max(props.zoom - 0.01, 0.1);
  emit("update:zoom", newZoom);
};

const handleZoomIncrease = () => {
  const newZoom = Math.min(props.zoom + 0.01, 2);
  emit("update:zoom", newZoom);
};

const startZoomDecrease = () => {
  handleZoomDecrease();
  intervalId = window.setInterval(handleZoomDecrease, 50);
};

const startZoomIncrease = () => {
  handleZoomIncrease();
  intervalId = window.setInterval(handleZoomIncrease, 50);
};

const stopZoomChange = () => {
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
  }
};

const handleZoomInput = (event: Event) => {
  const target = event.target as HTMLInputElement;
  // Permitir digitar livremente sem validação durante a digitação
  zoomInputValue.value = target.value;
};

const handleZoomChange = () => {
  // Validar e aplicar o zoom quando terminar de digitar (Enter ou sair do campo)
  let value = parseInt(zoomInputValue.value) || 100;
  value = Math.max(10, Math.min(200, value));
  zoomInputValue.value = value.toString();
  emit("update:zoom", value / 100);
};

const handleZoomBlur = () => {
  handleZoomChange();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: require('@/assets/images/logo-512.png')
      }, null, 8, _hoisted_3)
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "title" }, "RELATÓRIO", -1)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        onClick: handleZoomDecrease,
        onMousedown: startZoomDecrease,
        onMouseup: stopZoomChange,
        onMouseleave: stopZoomChange,
        onTouchstart: startZoomDecrease,
        onTouchend: stopZoomChange
      }, " - ", 32),
      _withDirectives(_createElementVNode("input", {
        type: "number",
        class: "value",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((zoomInputValue).value = $event)),
        onBlur: handleZoomBlur,
        onKeyup: _withKeys(handleZoomChange, ["enter"]),
        min: "10",
        max: "200"
      }, null, 544), [
        [_vModelText, zoomInputValue.value]
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "percent" }, "%", -1)),
      _createElementVNode("button", {
        onClick: handleZoomIncrease,
        onMousedown: startZoomIncrease,
        onMouseup: stopZoomChange,
        onMouseleave: stopZoomChange,
        onTouchstart: startZoomIncrease,
        onTouchend: stopZoomChange
      }, " + ", 32)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('download')))
      }, [
        _createVNode(_unref(svgIcon), {
          icon: "download",
          size: "1.25rem"
        })
      ]),
      _createElementVNode("button", null, [
        _createVNode(_unref(svgIcon), {
          icon: "print",
          size: "1.4rem"
        })
      ])
    ]),
    _createElementVNode("button", {
      class: "close",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('close')))
    }, [
      _createVNode(_unref(svgIcon), {
        icon: "close",
        size: "1rem"
      })
    ])
  ]))
}
}

})